import styled from '@emotion/styled'

export const Label = styled.label(({ theme }) => ({
  color: theme.textColor,
  fontSize: theme.fontSizeSm,
  fontWeight: 500,
}))
